import type { Dispatch, SetStateAction } from 'react';
import { z } from 'zod';
import { ApiListResponse, DEFAULT_PAGER, GetListApiFilter } from './api.types';
import { FilterType } from './misc.types';

export type SortOrder = 1 | 0 | -1 | null | undefined;

export type UseEntityDataResponseType<T> = {
  isLoading: boolean;
  pager: TDataTablePager;
  invoices?: ApiListResponse<T>;
  setPager?: Dispatch<SetStateAction<TDataTablePager>>;
  loadData: (params?: GetListApiFilter | undefined) => void;
  filters?: FilterType[];
  setFilters?: (arg0: FilterType[]) => void;
  onResetFilter?: () => void;
  searchTerm?: string;
  setSearchTerm?: (term: string) => void;
};

export const DataTablePagerSchema = z.object({
  first: z.number().default(DEFAULT_PAGER.first),
  rows: z.number().default(DEFAULT_PAGER.rows),
  page: z.number().default(DEFAULT_PAGER.page),
  pageCount: z.number().nullish(),
  sortField: z.string().nullish(),
  sortOrder: z.number().nullish(),
  multiSortMeta: z.array(z.any()).nullish(),
});

export type TDataTablePager<T = string> = {
  first: number;
  rows: number;
  page: number;
  pageCount?: number;
  sortField?: T;
  sortOrder?: SortOrder;
  multiSortMeta?: any[];
};

// ID Prefix Wiki: https://monetizenow.atlassian.net/wiki/spaces/PE/pages/1029439691/Id+Prefix
export type IdPrefix =
  | 'acct'
  | 'acdoc'
  | 'ctrct'
  | 'disc'
  | 'disct'
  | 'invc'
  | 'invce'
  | 'offer'
  | 'offr'
  | 'opp'
  | 'prod'
  | 'quot'
  | 'usgt'
  | 'crdt'
  | 'crnt'
  | 'pymt'
  | 'rfnd'
  | 'pmmd'
  | 'subs'
  | 'bilg'
  | 'cont'; // add accDoc later when api is available
